import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { capitalizeFirstLetter } from '@global/utils/StringService';
import { Address } from './types';

interface Props {
  title?: string;
  addressInfo: Address;
  isShowEditBtn?: boolean;
  selected: boolean;
  handleSelect: (index: number) => void;
  handleClose?: () => void;
  index: number;
}

export const AddressItem: FC<Props> = ({
  title,
  addressInfo,
  isShowEditBtn,
  selected,
  index,
  handleSelect,
  handleClose,
}) => {
  const { t } = useTranslation();
  const id = `address_${index}`;

  return (
    <div
      className={`address-doctor__item ${
        selected ? 'address-doctor__item__active' : ''
      }`}
    >
      <div className="address-doctor__item-input">
        <input
          onChange={() => handleSelect(index)}
          id={id}
          type="radio"
          name="address"
          checked={selected}
        />
      </div>
      <label htmlFor={id} className="address-doctor__item__wrapper">
        <div className="address-doctor__item__content">
          {title ? (
            <h4 className="address-doctor__item-title">{title}</h4>
          ) : null}
          <p className="address-doctor__item-address">
            <span>{addressInfo.addressOne}</span> <br />
            {addressInfo.addressTwo ? (
              <>
                <span>{addressInfo.addressTwo}</span> <br />
              </>
            ) : null}
            <span>
              {addressInfo.city},{' '}
              {capitalizeFirstLetter(addressInfo.state?.toLowerCase())}{' '}
              {addressInfo.zip}
            </span>
            <br />
            <span>{addressInfo.country.name}</span>
          </p>
        </div>
        {isShowEditBtn ? (
          <a
            onClick={handleClose}
            className="address-doctor__item-edit-btn"
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleClose?.();
              }
            }}
          >
            {t('addressDoctor.edit')}
          </a>
        ) : null}
      </label>
    </div>
  );
};
